
import styled from '@emotion/styled/macro';
import { LayoutRow } from '../../layout';

interface IPageLayoutRow {
    expand?: boolean;
}

const PageLayoutRow = styled(LayoutRow)<IPageLayoutRow>`
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    ${(props: IPageLayoutRow): string => (props.expand ? 'flex-grow: 1;' : '')}
`;

export const StyledPageLayoutRow = styled(PageLayoutRow)`
    margin-top: 0;
    margin-bottom: 24px;
    flex-wrap: nowrap;
    @media print {
      tr {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }
`;

export const Loader = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 1 40%;
    justify-content: center;

    & > svg {
        background-color: transparent;
    }
`;